import gql from 'graphql-tag';

import fileFragment from '~/shared/graphql-queries/files/file-fragment';

export default gql`
  fragment HomeTaskFragment on HomeTask {
    _id
    title
    notes
    files {
      ...FileFragment
    }
    data {
      courseCategory
      course
    }
  }
  ${fileFragment}
`;
